<template>
  <div class="container page">
    <van-nav-bar :title="this.videoInfo.vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video :id="'my-video'" class="video-js">
      </video>
    </div>
    <div class="movie-content">
      <div class="movie-descript">
        <p>{{videoInfo.vod_name||videoInfo.vod_name_yn_yu }}</p>
        <!-- <span>{{ this.videoInfo.count }}{{ $t("video.num_play") }}</span> -->
      </div>

      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>{{ $t("index.recmonmand") }}</span>
          </div>
        </div>
        <div class="movie-list">
          <div class="movie-play-item" @click="toPlayVideo(v.id)" v-for="(v, key) in moreVideoInfo" :key="key">
            <div>
              <img :src="v.vod_pic">
              <div>
                <div class="van-count-down">{{ v.time }}</div>
              </div>
            </div>
            <div>
              <p class="text-line4">{{v.vod_name||v.vod_name_yn_yu}}</p>
              <!-- <span>{{ v.count }}{{ $t("video.num_play") }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_play: false,
      is_see: 0
    };
  },
  watch: {
    "$route.query.id"() {
      if (localStorage.getItem("token")) {
        this.loadCurrentVideo();
      }
    },
  },
  methods: {
    back() {
      this.$router.push({ path: 'Home' })
    },
    loadCurrentVideo() {
      this.is_play = false;
      this.getVideoInfo();
    },
    getVideoInfo() {

      return this.$http({
        method: 'get',
        data: { id: this.$route.query.id },
        url: 'video_get_info'
      }).then(res => {
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.videoInfo.vod_pic;
        let videos = document.getElementById('my-video');
        if (videos) {
          videos.poster = this.cover;
        }
        this.getVideo();
      })

    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/PlayVideo', query: { id } });
      }

    },
    getMoreVideoItem() {
      return this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res => {
        this.moreVideoInfo = res.data;
      })
    },
    getVideoType(url) {
      const path = (url || "").split("?")[0].toLowerCase();
      if (path.endsWith(".m3u8")) {
        return "application/x-mpegURL";
      }
      if (path.endsWith(".webm")) {
        return "video/webm";
      }
      if (path.endsWith(".ogg") || path.endsWith(".ogv")) {
        return "video/ogg";
      }
      return "video/mp4";
    },
    getVideo() {
      if (!this.player || !this.nowPlayVideoUrl) {
        return;
      }
      this.player.src([{
        src: this.nowPlayVideoUrl,
        type: this.getVideoType(this.nowPlayVideoUrl) // 告诉videojs,这是一个hls流
      }]);
      this.player.load();
    },
    getUserInfo() {
      return this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          /* if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          } else { 
          }*/
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res;
      })
    },
    handleVideoTimeUpdate() {
      if (!this.player || !this.is_play || this.is_see != 0) {
        return;
      }
      const ct = Math.round(this.player.currentTime());
      if (ct >= 180) {
        this.player.pause();
        this.is_play = false;
        this.$toast(this.$t("video.buy"));
      }
    },
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      const vm = this;
      this.player = videojs('my-video', {
        height: "200px",
        preload: "auto", // 预加载
        controls: true,  // 显示播放的控件
        multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      }, function () {
        this.on("play", () => {
          vm.is_play = true;
        });
        this.on("pause", () => {
          vm.is_play = false;
        });
        this.on("timeupdate", vm.handleVideoTimeUpdate);
      });
      Promise.all([this.getUserInfo(), this.getMoreVideoItem()]).then(() => {
        vm.loadCurrentVideo();
      });
    }

  },

  destroyed() {
    this.is_play = false;
    if (this.player) {
      this.player.dispose()
      this.player = null;
    }
  }
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}

.movie-content {
  flex: 1;
  overflow-y: auto;
}

.movie-content .movie-descript {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
  color: @white;
}

.movie-content .movie-descript p {
  font-size: 30px;
  font-weight: 700;
}

.movie-content .movie-descript span {
  color: #979799;
}

.movie-content .movie-body {
  width: calc(100% - 20px);
  margin: 0 auto;
}

::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}

.movie-content .movie-body .movie-title {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-content .movie-body .movie-title>div:first-child {
  width: 410px;
}

.movie-content .movie-body .movie-title>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: @theme2;
}

.movie-content .movie-body .movie-title>div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: @theme2;
  border-radius: 25px;
  margin-right: 10px;
}

.movie-play-item {
  height: 200px;
  margin: @md1;
  border-radius: 10px;
  position: relative;
  display: flex;
  background-color: @theme1;
  margin-bottom: 20px;
  border: 1px solid @theme2;
}

.movie-play-item>div {
  height: 100%;
}

.movie-play-item>div:first-child {
  width: 200px;
  position: relative;
}

.movie-play-item>div:first-child>img {
  width: 100%;
  height: 100%;
  border-radius: 10px 0 0 10px;
}

.movie-play-item>div:first-child>div {
  position: absolute;
  width: 100%;
  height: 30px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  background-color: rgba(0, 0, 0, .4);
  border-radius: 0 0 0 10px;
}

.movie-play-item>div:first-child>div .van-count-down {
  color: #fff;
  font-size: 25px;
}

.movie-play-item>div:nth-child(2) p {
  width: 500px;
  height: 60px;
  font-size: 30px;
  line-height: 32px;
  word-break: break-all;
  overflow: hidden;
  color: @white;
}

.movie-play-item>div:nth-child(2) span {
  color: @white;
}

.movie-play-item>div:nth-child(2) {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

abbr,
address,
article,
aside,
audio,
b,
blockquote,
body,
canvas,
caption,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
samp,
section,
small,
span,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}
</style>
